import { createSlice } from "@reduxjs/toolkit";

const pencil=createSlice({
  name:"pencil",
  initialState:{p:false},
  reducers:{
    setPencilS:(state,action)=>{
      state.p=action.payload
    }
  }
});

export const {setPencilS}=pencil.actions
export default pencil.reducer